// const new_service_basis = window.gtaAiConfig.service_basis
 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis
 let service_data=getEnv(tag).service_data

export default {
    /**
     * 公开数据集首页展示（分页加模糊查询）
     */
    getDatasetHallList: `${new_service_basis}/ai/training/datasetHall/getDatasetHallList`,
    /**
     * 是否公开数据集
     */
    openPubDataset: `${new_service_basis}/ai/training/datasetHall/openPubDataset`,
    /**
     * 是否收藏数据集
     */
    collectionPubDataset: `${new_service_basis}/ai/training/datasetHall/collectionPubDataset`,
    /**
     * 上传数据集
     */
    insertDataset: `${new_service_basis}/ai/training/datasetHall/insertDataset`,
    /**
     * 修改数据集
     */
    updateDataset: `${new_service_basis}/ai/training/datasetHall/updateDataset`,
    /**
     删除数据集
     */
    deletePubDataset: `${new_service_basis}/ai/training/datasetHall/deletePubDataset`,
    /**
     * 根据数据集id获取数据集详情
     */
    getDatasetInfoByDatasetId: `${new_service_basis}/ai/training/datasetHall/getDatasetInfoByDatasetId`,
    /**
     * 根据数据集id获取数据集文件
     */
    getDatasetFileByDatasetId: `${new_service_basis}/ai/training/datasetHall/getDatasetFileByDatasetId`,
    /**
     * 根据数据集id上传数据集文件
     */
    uploadFileByDatasetId: `${new_service_basis}/ai/training/datasetHall/uploadFileByDatasetId`,
    /**
     * 根据文件id重命名数据集文件
     */
    updateFileNameByFileId: `${new_service_basis}/ai/training/datasetHall/updateFileNameByFileId`,
    /**
     * 根据文件id删除数据集文件
     */
    deleteFileByFileId: `${new_service_basis}/ai/training/datasetHall/deleteFileByFileId`,
    /**
     * 批量删除数据集文件
     */
    batchDeleteFile: `${new_service_basis}/ai/training/datasetHall/batchDeleteFile`,
    /**
     * 查询行业领域
     */
     getIndustryField: `${new_service_basis}/ai/training/datasetHall/getIndustryField`,
    /**
     * 通过数据集ID下载文件
     */
    downPubDataset: `${new_service_basis}/ai/training/datasetHall/downPubDataset`,
    /**
    *  查询引用数据集列表
    */
    getQuoteDatasetList: `${new_service_basis}/ai/training/dataCenter/getQuoteDatasetList`,
    /**
    *  添加引用数据集
    */
    quoteDataset: `${new_service_basis}/ai/training/dataCenter/quoteDataset`,
    /**
    *  引用数据集详情添加文件
    */
    quoteDatasetFile: `${new_service_basis}/ai/training/dataCenter/quoteDatasetFile`,


    /**
     * 获取数据类型
     */
    getComDictionary: `${new_service_basis}/ai/training/personlSpace/getComDictionary`,
};
